// Tournaments API for DIOS10
import apiClient from './client';
import { API_ENDPOINTS } from './config';

export const tournamentsApi = {
    // Create tournament
    create: async (tournamentData) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.TOURNAMENTS.CREATE, tournamentData);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get active tournaments
    getActive: async (filters = {}) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_ACTIVE, {
                params: filters
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    getPublishedMonthlyRankings: async () => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_PUBLISHED_MONTHLY_RANKINGS);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get tournament by ID
    getById: async (id) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_BY_ID(id));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Enter tournament
    enter: async (id, entryData) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.TOURNAMENTS.ENTER(id), entryData);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get tournament rankings
    getRankings: async (id, limit = 100) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.RANKINGS(id), {
                params: { limit }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get user's registered tournaments
    getUserRegistered: async (userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_USER_REGISTERED(userId));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get tournament formation
    getFormation: async (id, userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_FORMATION(id), {
                params: { userId }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update tournament formation
    updateFormation: async (id, data) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.TOURNAMENTS.UPDATE_FORMATION(id), data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get card IDs used in active gameweeks
    getUsedCardsInActiveGameweeks: async (userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_USED_CARDS_ACTIVE_GAMEWEEKS(userId));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get card IDs used in same gameweek
    getUsedCardsInGameweek: async (userId, gameweekId, excludeTournamentId = null) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_USED_CARDS_GAMEWEEK, {
                params: { userId, gameweekId, excludeTournamentId }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Check if a team plays during a gameweek or tournament period
    checkTeamPlaysInGameweek: async (teamId, gameweekId, tournamentId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.CHECK_TEAM_PLAYS_IN_GAMEWEEK, {
                params: { teamId, gameweekId, tournamentId }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get card scores for a tournament formation
    getFormationScores: async (id, userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.TOURNAMENTS.GET_FORMATION_SCORES(id), {
                params: { userId }
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default tournamentsApi;

